import { render, staticRenderFns } from "./lista.vue?vue&type=template&id=c93ec9e8&scoped=true&"
import script from "./lista.vue?vue&type=script&lang=ts&"
export * from "./lista.vue?vue&type=script&lang=ts&"
import style0 from "./lista.vue?vue&type=style&index=0&id=c93ec9e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93ec9e8",
  null
  
)

export default component.exports